import { ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export const NavbarItem = ({ item }) => {
   const { title, component } = item
   const navigate = useNavigate()
   const handleNavigate = (route) => {
      navigate(route)
   }
  return (
   <ListItem sx={{ flexDirection: 'column', alignItems: 'center', textAlign:"center" }} onClick={() => handleNavigate(item.route)}>
      <ListItemIcon sx={{ minWidth: 0 }}>
         { component }
      </ListItemIcon>
      <ListItemText>
         <Typography component="span" variant="caption">{ title }</Typography>
      </ListItemText>
   </ListItem>
  )
}
